import { useEffect, useRef } from 'react';
import { Layer, Stage } from 'react-konva';
import { SheetCorrectionContext, useSheetCorrection } from './SheetCorrectionProvider';
import SheetCorrectionRow from './SheetCorrectionRow';

function SheetCorrectionLayer(props) {
	const { lattices, setStage } = useSheetCorrection();
	const { size, originalSize } = props;
	const stageRef = useRef(null);
	const layerRef = useRef(null);
	const scale = size.height / originalSize.height;

	useEffect(() => {
		setStage(stageRef.current);
	}, [stageRef.current]);

	return (
		<SheetCorrectionContext.Consumer>
			{value => (
				<Stage width={size.width} height={size.height} ref={stageRef}>
					<SheetCorrectionContext.Provider value={value}>
						<Layer ref={layerRef} width={originalSize.width} height={originalSize.height} scaleX={scale} scaleY={scale}>
							{lattices && lattices.map((lattice, rowIdx) => <SheetCorrectionRow lattice={lattice} rowIdx={rowIdx} />)}
						</Layer>
					</SheetCorrectionContext.Provider>
				</Stage>
			)}
		</SheetCorrectionContext.Consumer>
	);
}

export default SheetCorrectionLayer;
